import { Grid } from 'antd';
import { useMemo } from 'react';
import { Breakpoint, responsiveArray } from 'antd/es/_util/responsiveObserver';

export const useScreenSize = () => {
  const screens = Grid.useBreakpoint();
  return useMemo(
    () =>
      responsiveArray.reduce<Breakpoint | undefined>(
        (value, breakpoint) =>
          value || (screens[breakpoint] ? breakpoint : undefined),
        undefined
      ),
    [screens]
  );
};
